import consumer from "./consumer"

function setupAdminSfShiptoSyncSubscription() {
  const card = document.getElementById('sf-sync-progress-card');
  if (!card) return; // not on the admin sync page

  if (window.adminSfShiptoSyncSubscription) {
    window.adminSfShiptoSyncSubscription.unsubscribe();
    window.adminSfShiptoSyncSubscription = null;
  }

  const bar = document.getElementById('sf-sync-progress-bar');
  const log = document.getElementById('sf-sync-progress-log');

  const problemsFilter = document.getElementById('sf-dry-run-problems-filter');
  if (problemsFilter) {
    // Assign (not addEventListener) so repeated turbolinks loads don't stack handlers.
    problemsFilter.oninput = filterProblemRows;
  }

  function show(message, type) {
    card.style.display = 'block';
    const line = document.createElement('div');
    line.textContent = message;
    if (type === 'error')   line.style.color = '#c00';
    if (type === 'success') line.style.color = '#070';
    log.appendChild(line);
    log.scrollTop = log.scrollHeight;
  }

  function setProgress(idx, total) {
    if (!total) return;
    const pct = Math.round((idx / total) * 100);
    bar.style.width = pct + '%';
    bar.textContent = pct + '% (' + idx + '/' + total + ')';
  }

  window.adminSfShiptoSyncSubscription = consumer.subscriptions.create(
    { channel: "SalesforceShiptoSyncChannel" },
    {
      connected() { console.log("Connected to SalesforceShiptoSyncChannel"); },
      disconnected() { console.log("Disconnected from SalesforceShiptoSyncChannel"); },
      received(data) {
        if (typeof data.index === 'number' && typeof data.total === 'number') {
          setProgress(data.index, data.total);
        }
        if (data.message) show(data.message, data.type);

        if (data.stats) {
          renderDryRunStats(data.stats);
        }

        // Reload only after a real sync completes so the SalesforceSyncLog tables refresh.
        // Dry runs don't write logs — leave the page so the user can read the stats.
        if (data.completed && data.type === 'success' && !data.dry_run) {
          setTimeout(() => window.location.reload(), 4000);
        }
      }
    }
  );
}

function renderDryRunStats(stats) {
  const card = document.getElementById('sf-dry-run-stats-card');
  if (!card) return;
  card.style.display = 'block';

  const counts = document.getElementById('sf-dry-run-counts');
  counts.innerHTML = '';
  const countRows = [
    ['SF Accounts queried', stats.total_sf_accounts],
    ['DD shiptos in DB',    stats.total_dd_shiptos],
    ['Would create',        stats.would_create],
    ['Would update',        stats.would_update],
    ['No change',           stats.would_no_change],
    ['Would skip',          stats.would_skip],
    ['Would fail',          stats.would_fail],
    ['Problems hidden (contractor owner)', stats.excluded_problem_accounts || 0]
  ];
  countRows.forEach(([label, value]) => {
    const tr = document.createElement('tr');
    tr.innerHTML = `<th style="width: 60%;">${label}</th><td>${value}</td>`;
    counts.appendChild(tr);
  });

  const fieldFailures = document.getElementById('sf-dry-run-field-failures');
  fieldFailures.innerHTML = '';
  const ffEntries = Object.entries(stats.field_failure_counts || {}).sort((a, b) => b[1] - a[1]);
  if (ffEntries.length === 0) {
    fieldFailures.innerHTML = '<tr><td class="text-muted">No field failures.</td></tr>';
  } else {
    ffEntries.forEach(([field, count]) => {
      const tr = document.createElement('tr');
      tr.innerHTML = `<th style="width: 60%;">${field}</th><td>${count}</td>`;
      fieldFailures.appendChild(tr);
    });
  }

  const customerGroups = document.getElementById('sf-dry-run-customer-groups');
  if (customerGroups) {
    customerGroups.innerHTML = '';
    const cgEntries = Object.entries(stats.customer_group_counts || {}).sort((a, b) => b[1] - a[1]);
    if (cgEntries.length === 0) {
      customerGroups.innerHTML = '<tr><td class="text-muted">No CustomerGroup__c values.</td></tr>';
    } else {
      cgEntries.forEach(([group, count]) => {
        const tr = document.createElement('tr');
        tr.innerHTML = `<th style="width: 60%;"><code>${escapeHtml(group)}</code></th><td>${count}</td>`;
        customerGroups.appendChild(tr);
      });
    }
  }

  const sfBaseUrl = card.dataset.sfBaseUrl || '';
  const problems = document.getElementById('sf-dry-run-problems');
  problems.innerHTML = '';
  const problemList = stats.problem_accounts || [];
  if (problemList.length === 0) {
    problems.innerHTML = '<tr data-placeholder="1"><td colspan="5" class="text-muted">No problem accounts. Everything would sync cleanly.</td></tr>';
  } else {
    problemList.forEach(p => {
      const tr = document.createElement('tr');
      const outcomeBadge = p.outcome === 'would_fail'
        ? '<span class="badge badge-danger">would fail</span>'
        : '<span class="badge badge-warning">would skip</span>';
      const fieldsHtml = (p.failed_fields || []).map(f => `<div><code>${escapeHtml(f)}</code></div>`).join('');
      const idCell = (p.sf_account_id && sfBaseUrl)
        ? `<td><a href="${sfBaseUrl}/lightning/r/Account/${encodeURIComponent(p.sf_account_id)}/view" target="_blank" rel="noopener"><code>${escapeHtml(p.sf_account_id)}</code></a></td>`
        : `<td><code>${escapeHtml(p.sf_account_id || '')}</code></td>`;
      tr.innerHTML =
        idCell +
        `<td>${escapeHtml(p.shipto || '')}</td>` +
        `<td>${escapeHtml(p.name || '')}</td>` +
        `<td>${outcomeBadge}</td>` +
        `<td>${fieldsHtml}</td>`;
      problems.appendChild(tr);
    });
  }

  filterProblemRows(); // re-apply any active filter to the freshly rendered rows
}

// Client-side row filter for the "Problem accounts" table. Matches the term
// against the whole row text (id, shipto, name, outcome, failed fields).
function filterProblemRows() {
  const input = document.getElementById('sf-dry-run-problems-filter');
  const tbody = document.getElementById('sf-dry-run-problems');
  if (!input || !tbody) return;

  const term = input.value.trim().toLowerCase();
  let visible = 0;
  tbody.querySelectorAll('tr').forEach(row => {
    if (row.dataset.placeholder) return; // leave the empty-state row alone
    if (row.dataset.noMatch) return;     // skip our own "no matches" row
    const match = !term || row.textContent.toLowerCase().includes(term);
    row.style.display = match ? '' : 'none';
    if (match) visible++;
  });

  let noMatchRow = tbody.querySelector('tr[data-no-match]');
  if (term && visible === 0 && !tbody.querySelector('tr[data-placeholder]')) {
    if (!noMatchRow) {
      noMatchRow = document.createElement('tr');
      noMatchRow.dataset.noMatch = '1';
      noMatchRow.innerHTML = '<td colspan="5" class="text-muted">No matching problem accounts.</td>';
      tbody.appendChild(noMatchRow);
    }
    noMatchRow.style.display = '';
  } else if (noMatchRow) {
    noMatchRow.style.display = 'none';
  }
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

function teardownAdminSfShiptoSyncSubscription() {
  if (window.adminSfShiptoSyncSubscription) {
    window.adminSfShiptoSyncSubscription.unsubscribe();
    window.adminSfShiptoSyncSubscription = null;
  }
}

// Dedupe across module re-evaluations so handlers don't stack on repeated navigations
// (mirrors the salesforce_refresh_channel.js pattern noted in CLAUDE.md).
if (window._adminSfShiptoSyncLoadHandler) {
  document.removeEventListener('turbolinks:load', window._adminSfShiptoSyncLoadHandler);
}
if (window._adminSfShiptoSyncBeforeCacheHandler) {
  document.removeEventListener('turbolinks:before-cache', window._adminSfShiptoSyncBeforeCacheHandler);
}
window._adminSfShiptoSyncLoadHandler = setupAdminSfShiptoSyncSubscription;
window._adminSfShiptoSyncBeforeCacheHandler = teardownAdminSfShiptoSyncSubscription;
document.addEventListener('turbolinks:load', window._adminSfShiptoSyncLoadHandler);
document.addEventListener('turbolinks:before-cache', window._adminSfShiptoSyncBeforeCacheHandler);
